import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6afe11a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search_div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动名称：", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态：", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("获取优惠券")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "优惠券查询", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_18 = { class: "check_coupon" }
const _hoisted_19 = { class: "icon_div" }

import { ref, onMounted, getCurrentInstance } from 'vue'
  import pageTitle from '@/components/pageTitle.vue';
  import { getActivityList,addActivity,delActivity,getActivityDetail,editActivity,getCouponList } from '@/axios/smartMarket';
  import { ElMessage,ElMessageBox } from 'element-plus';
  import { downUrl } from '@/config/index';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'appletsCoupon',
  setup(__props) {

  let tableData = ref([]);
  let status = ref()
  let names = ref()
  let showApp = ref(false)
  let form = ref({
    id: 0,
    activity_name: '',
    status: 1
  })
  let allCoupon = ref([])
  let couponList = ref([])
  let couponDia = ref(false);
  let { proxy } = getCurrentInstance() as any;

  onMounted(() => {
    getInfos();
  })

  //获取列表
  function getInfos(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getActivityList({
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
      activity_name: names.value,
      status: status.value
    }).then((data:any) => {
      tableData.value = data;
    }).catch((err:any)=>{})
  }

  //获取优惠券
  function getCoupon(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getCouponList({
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
      page: 1,
      page_size: 50
    }).then((data:any) => {
      let newarr:any = [], nowDate = new Date().getTime();
      data.map((item:any) => {
        let endTime = new Date(item.end_time).getTime();
        if(nowDate < endTime){
          newarr.push(item)
        }
      })
      allCoupon.value = newarr;
    }).catch((err:any)=>{})
    
  }

  //新增、编辑弹窗
  function showApplet(id?:number){
    showApp.value = true;
    if(id){
      getActivityDetail({
        activity_id: id
      }).then((data:any) => {
        form.value = data;
        let newarr:any = [];
        data.coupon_list.map((item:any) => {
          newarr.push({
            couponid: item.coupon_id,
            title: item.coupon_name,
            type: Number(item.coupon_type),
            oncegetnum: item.receive_num,
            total_num: item.launch_num,
            validate_range: item.validate_range,
            moneys: item.moneys
          })
        })
        couponList.value = newarr;
      }).catch((err:any)=>{})
    }
  }

  //删除
  function delApp(id:number){
    ElMessageBox.confirm('是否删除该活动').then(() => {
      delActivity({
        activity_id: id
      }).then((data:any) => {
        ElMessage('删除成功')
        getInfos();
        closeInfo();
      }).catch((err:any) => {})
      
    }).catch(() => {
      
    })
  }

  //关闭弹窗
  function closeInfo(){
    showApp.value = false;
    form.value = {
      id: 0,
      activity_name: '',
      status: 1
    }
    couponList.value = [];
  }

  //弹窗确定
  function queryClick(){
    if(!form.value.activity_name.trim()){
      ElMessage('请输入活动名称');
      return false;
    }
    // if(form.value.status == ''){
    //   ElMessage('请选择活动状态');
    //   return false;
    // }
    if(couponList.value.length == 0){
      ElMessage('请选择优惠券');
      return false;
    }
    let arr:any = [];
    couponList.value.map((item:any) => {
      let validate_range = item.validate_range;
      if(!validate_range){
        if(item.valid_type == 2){
          if(item.expire_date){
            validate_range = item.start_time.substring(0, 10).replace(/-/g,'.') + '-' + item.expire_date.substring(0, 10).replace(/-/g,'.')
          }
          else{
            validate_range = item.start_time.substring(0, 10).replace(/-/g,'.') + '-' + item.valid_end_time.substring(0, 10).replace(/-/g,'.')
          }
        }
        else{
          console.log(item)
          validate_range = item.valid_start_time.substring(0, 10).replace(/-/g,'.') + '-' + item.valid_end_time.substring(0, 10).replace(/-/g,'.')
        }
      }
      let moneys = item.moneys;
      if(!moneys){
        if(item.type==2 || item.type==5){
          moneys = '券';
        }
        if(item.type == 1){
          moneys = '¥' + item.money
        }
        if(item.type == 3){
          moneys = item.to_use_time + '分钟'
        }
        if(item.type == 4){
          moneys = item.discount_rate/10 + '折'
        }
      }
      arr.push({
        "coupon_id": item.couponid,
        "coupon_name": item.title,
        "coupon_type": item.type,
        "receive_num": item.oncegetnum,
        "launch_num": item.total_num,
        "validate_range": validate_range,
        "moneys": moneys
      })
    })
    //新增
    if(!form.value.id){
      let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
      addActivity({
        brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
        company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
        activity_name: form.value.activity_name,
        status: form.value.status,
        coupon_list: JSON.stringify(arr)
      }).then((data:any) => {
        ElMessage('添加成功')
        getInfos();
        closeInfo();
      }).catch((err:any)=>{})
    }
    else{
      editActivity({
        activity_id: form.value.id,
        activity_name: form.value.activity_name,
        status: form.value.status,
        coupon_list: JSON.stringify(arr)
      }).then((data:any) => {
        ElMessage('编辑成功')
        getInfos();
        closeInfo();
      }).catch((err:any)=>{})
    }
  }

  //删除已选优惠券
  function delCoupon(num:number){
    couponList.value.splice(num,1);
  }

  //获取所有优惠券
  function showCoupon(){
    couponDia.value = true;
    getCoupon();
  }

  //选择优惠券
  function couponClick(row:any){
    let has = false;
    couponList.value.some((item:any) => {
      if(item.couponid == row.couponid){
        has = true;
        return true;
      }
    })
    if(!has){
      couponList.value.push(row)
    }
  }
  //清空优惠券
  function removeAll(){
    couponList.value = [];
  }

  //下载二维码
  function downs(id:number){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '');
    let compid = aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id;
    let brandid = aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id;
    return `${proxy.$downUrl}/admin/qrcode/createCouponQrcode?parent_id=${brandid}&company_id=${compid}&activity_id=${id}`;
  }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DArrowLeft = _resolveComponent("DArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(pageTitle, { title: "小程序优惠券运营" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_input, {
        modelValue: _unref(names),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(names) ? (names).value = $event : names = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: _unref(status),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
        clearable: "",
        filterable: "",
        placeholder: "请选择状态"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "启用",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "禁用",
            value: 0
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: getInfos
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showApplet()))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _unref(tableData),
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "activity_name",
          label: "活动名称"
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.status==0?'停用':'启用'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "最后修改时间" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.updated_at), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "260px"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("a", {
              href: downs(scope.row.id),
              class: "down_a"
            }, "下载二维码", 8, _hoisted_6),
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              onClick: ($event: any) => (showApplet(scope.row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              onClick: ($event: any) => (delApp(scope.row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(showApp),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showApp) ? (showApp).value = $event : showApp = $event)),
      title: _unref(form).id?'编辑活动':'新增活动',
      width: "1000px",
      onClose: _cache[7] || (_cache[7] = ($event: any) => (closeInfo()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: queryClick
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (closeInfo()))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(form),
          "label-width": "120px",
          "label-position": "left",
          ref: "brandDiaForm",
          class: "brand_from"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "活动名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(form).activity_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).activity_name) = $event)),
                  placeholder: "请输入活动名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "is_enable"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).status,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "优惠券选择" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: showCoupon
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table, {
                  data: _unref(couponList),
                  border: "",
                  style: {"width":"100%"},
                  class: "form_table"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "title",
                      label: "优惠券名称"
                    }),
                    _createVNode(_component_el_table_column, { label: "优惠券类型" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", null, _toDisplayString(scope.row.type==1?'现金券':'') + _toDisplayString(scope.row.type==2?'物品券':'') + _toDisplayString(scope.row.type==3?'房费券':'') + _toDisplayString(scope.row.type==4?'折扣券':'') + _toDisplayString(scope.row.type==5?'组合券':''), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "一次点击领取数量" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_input, {
                          modelValue: scope.row.oncegetnum,
                          "onUpdate:modelValue": ($event: any) => ((scope.row.oncegetnum) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "投放数量" }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.total_num==0?'不限制':scope.row.total_num), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "操作" }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          text: "",
                          type: "primary",
                          onClick: ($event: any) => (delCoupon(scope.$index))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(couponDia),
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(couponDia) ? (couponDia).value = $event : couponDia = $event)),
      title: "添加优惠券",
      width: "1000px",
      onClose: _cache[11] || (_cache[11] = ($event: any) => (_isRef(couponDia) //@ts-ignore
 ? couponDia.value = false : couponDia=false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_15,
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: getCoupon
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(couponDia) //@ts-ignore
 ? couponDia.value = false : couponDia=false))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_table, {
            data: _unref(allCoupon),
            border: "",
            style: {"width":"40%"},
            onRowClick: couponClick,
            stripe: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "title",
                label: "优惠券名称"
              }),
              _createVNode(_component_el_table_column, { label: "优惠券类型" }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.type==1?'现金券':'') + _toDisplayString(scope.row.type==2?'物品券':'') + _toDisplayString(scope.row.type==3?'房费券':'') + _toDisplayString(scope.row.type==4?'折扣券':'') + _toDisplayString(scope.row.type==5?'组合券':''), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "状态" }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.status==0?'停用':'') + _toDisplayString(scope.row.status==1?'启用':'') + _toDisplayString(scope.row.status==2?'已结束':''), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_icon, {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (removeAll()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DArrowLeft)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_table, {
            data: _unref(couponList),
            border: "",
            style: {"width":"40%"},
            stripe: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "title",
                label: "优惠券名称"
              }),
              _createVNode(_component_el_table_column, { label: "优惠券类型" }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.type==1?'现金券':'') + _toDisplayString(scope.row.type==2?'物品券':'') + _toDisplayString(scope.row.type==3?'房费券':'') + _toDisplayString(scope.row.type==4?'折扣券':'') + _toDisplayString(scope.row.type==5?'组合券':''), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "状态" }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.status==0?'停用':'') + _toDisplayString(scope.row.status==1?'启用':'') + _toDisplayString(scope.row.status==2?'已结束':''), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})